import { cn } from '../../../lib/utils';
import type { SegmentedControlProps } from './types';

export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  ariaLabel,
  className,
  optionClassName,
}: SegmentedControlProps<T>) {
  return (
    <div
      role="radiogroup"
      aria-label={ariaLabel}
      className={cn(
        'inline-flex items-center gap-1 rounded-12 border border-control-border p-1',
        className,
      )}
    >
      {options.map((opt) => {
        const selected = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={selected}
            aria-disabled={opt.disabled || undefined}
            disabled={opt.disabled}
            title={opt.disabled ? opt.disabledReason : undefined}
            onClick={opt.disabled ? undefined : () => onChange(opt.value)}
            className={cn(
              'inline-flex h-8 cursor-pointer items-center justify-center gap-2 rounded-8 border px-3 py-1 text-sm text-text-secondary transition-colors',
              'focus-visible:border-focus focus-visible:outline-none',
              selected
                ? 'border-chip-selected-border bg-chip-selected-bg'
                : 'border-control-border hover:bg-chip-hover',
              opt.disabled &&
                'cursor-not-allowed border-transparent text-muted-foreground hover:bg-transparent',
              optionClassName,
            )}
          >
            {opt.icon ? (
              <span className="flex size-4 shrink-0 items-center">{opt.icon}</span>
            ) : null}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
